import { render, staticRenderFns } from "./DataPanelSection.vue?vue&type=template&id=68de3d7c"
import script from "./DataPanelSection.vue?vue&type=script&lang=js"
export * from "./DataPanelSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports